import api from '../../api'
import moment from 'moment'

import {
    CREATE_NEW_APPRAISALREPORT,
    DELETE_APPRAISALREPORT,
    GET_APPRAISALREPORT,
    RESET_APPRAISALREPORT,
    SET_APPRAISALREPORT,
    SET_APPRAISALREPORT_FILE_ID,
    SET_APPRAISALREPORT_ID,
    SET_APPRAISALREPORT_DATE_CREATED,
    SET_APPRAISALREPORT_DATE_MODIFIED,
    SET_APPRAISALREPORT_DIRTYNESS,
    SET_APPRAISALREPORT_NUMBER,
    SET_APPRAISALREPORT_PARENT_PATH,
    SET_APPRAISALREPORT_PATH,
    UPDATE_APPRAISALREPORT,
    SET_APPRAISALREPORT_DESCRIPTION,
    SET_APPRAISALREPORT_REPORTDATE,
    SET_APPRAISALREPORT_SEND_TO_BDE,
    SET_APPRAISALREPORT_TITLE,
    SET_APPRAISALREPORT_VERSION,
    SET_APPRAISALREPORT_PETITIONER,
    SET_APPRAISALREPORT_PETITIONER_TYPE,
    SET_APPRAISALREPORT_ENTITY,
    SET_APPRAISALREPORT_SUPERVISOR,
    SET_APPRAISALREPORT_APPRAISER,
    SET_APPRAISALREPORT_COVER_PHOTO_URL,
    SET_APPRAISALREPORT_STATUS,
    SET_APPRAISALREPORT_FULL_NUMBER,
    SET_APPRAISALREPORT_SIGNATURE_SV_NAME,
    SET_APPRAISALREPORT_SIGNATURE_SV_BASE64,
    SET_APPRAISALREPORT_SIGNATURE_SV_DATE,
    SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL,
    SET_APPRAISALREPORT_SIGNATURE_SV_UID,
    SET_APPRAISALREPORT_SIGNATURE_AP_NAME,
    SET_APPRAISALREPORT_SIGNATURE_AP_BASE64,
    SET_APPRAISALREPORT_SIGNATURE_AP_DATE,
    SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL,
    SET_APPRAISALREPORT_SIGNATURE_AP_UID,
    SET_APPRAISALREPORT_IS_SIGNED,
    SET_APPRAISALREPORT_IS_SV_SIGNED,
    SET_APPRAISALREPORT_IS_AP_SIGNED,

} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null,
    full_number: null,
    reportdate: null,
    send_to_bde: false,
    title: null,
    version: null,
    petitioner: null,
    petitioner_type: {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    entity: null,
    supervisor: {
        complete_name: 'López-Doriga, Ferran',
        id: '-L-K_d-_ZNBuuqfNtjJy',
        name: 'Ferran',
        path: 'supervisors',
        prof_assoc_reg_number: '9830-2',
        surnames: 'López-Doriga',
        tin: '46108653R'
    },
    appraiser: null,
    cover_photo_url: null,
    status: {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Taxador',
        name_es: '1/6 - Falta la firma del Tasador',
        name_en: '1/6 - Needs to be signed by Appraiser'
    },
    signature_sv_name: null,
    signature_sv_base64: null,
    signature_sv_date: null,
    signature_sv_email: null,
    signature_sv_uid: null,
    signature_ap_name: null,
    signature_ap_base64: null,
    signature_ap_date: null,
    signature_ap_email: null,
    signature_ap_uid: null,
    is_signed: null,
    is_sv_signed: null,
    is_ap_signed: null,

}

const state = default_state

const actions = {

    CREATE_NEW_APPRAISALREPORT: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key
                    const default_appraisalreportdate = moment(res.date_created, 'x').format('YYYY-MM-DD')

                    commit(SET_APPRAISALREPORT_ID, res.key)
                    commit(SET_APPRAISALREPORT_DATE_CREATED, res.date_created)
                    commit(SET_APPRAISALREPORT_DATE_MODIFIED, res.date_modified)
                    commit(SET_APPRAISALREPORT_NUMBER, data.number)
                    commit(SET_APPRAISALREPORT_FULL_NUMBER, data.full_number)
                    commit(SET_APPRAISALREPORT_PATH, res.path)
                    commit(SET_APPRAISALREPORT_PARENT_PATH, data.parent_path)
                    commit(SET_APPRAISALREPORT_REPORTDATE, default_appraisalreportdate)
                    commit(SET_APPRAISALREPORT_VERSION, data.version)
                    commit(SET_APPRAISALREPORT_FILE_ID, data.file_id)

                    api.set_value({
                        value: res.key,
                        path: data.path + new_created_key + '/' + 'id',
                        save_timestamp: false
                    }).then((res) => {
                        api.set_value({
                            value: default_appraisalreportdate,
                            path: data.path + new_created_key + '/' + 'reportdate',
                            save_timestamp: false
                        }).then((res) => {
                            api.set_value({
                                value: data.file_id,
                                path: data.path + new_created_key + '/' + 'file_id',
                                save_timestamp: false
                            }).then((res) => {
                                api.set_value({
                                    value: data.number,
                                    path: data.path + new_created_key + '/' + 'number',
                                    save_timestamp: false
                                }).then((res) => {
                                    api.set_value({
                                        value: data.full_number,
                                        path: data.path + new_created_key + '/' + 'full_number',
                                        save_timestamp: false
                                    }).then((res) => {
                                        api.set_value({
                                            value: data.parent_path,
                                            path: data.path + new_created_key + '/' + 'parent_path',
                                            save_timestamp: false
                                        }).then((res) => {
                                            api.set_value({
                                                value: data.version,
                                                path: data.path + new_created_key + '/' + 'version',
                                                save_timestamp: false
                                            }).then((res) => {
                                                const object = {}
                                                object[new_created_key] = {
                                                    description: '',
                                                    id: new_created_key,
                                                    number: data.number,
                                                    version: data.version
                                                }
                                                api.update({
                                                    object: object,
                                                    path: data.parent_path,
                                                    save_timestamp: false
                                                }).then(res => resolve({key: new_created_key}))
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })

        })

    },
    DELETE_APPRAISALREPORT: ({state, commit, rootState}, data) => {

        // console.log('DELETE_APPRAISALREPORT path check: ' + data.path)
        // console.log('DELETE APPRAISALREPORT parent_path check: ' + data.parent_path)

        // delete from appraisalreports/appraisalreport_key
        api.delete({key: data.key, path: data.path})
            .then((res) => {

                const date_modified = res.date_modified

                // delete from appraisalfiles/appraisalfile_key/appraisalreports/appraisalreport_key
                api.delete({key: data.key, path: data.parent_path})
                    .then((res) => {
                        commit(RESET_APPRAISALREPORT)

                        api.set_value({
                            value: date_modified,
                            path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                            save_timestamp: false
                        })
                            .then((res) => {

                            })

                    })
            })

    },
    GET_APPRAISALREPORT: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then(res => resolve(res))
        })

    },
    SET_APPRAISALREPORT: ({state, commit, rootState}, data) => {

        // console.log('set_appraisalreport data:')
        // console.log(data)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_APPRAISALREPORT, res)
            })

    },
    RESET_APPRAISALREPORT: ({state, commit, rootState}) => {
        commit(RESET_APPRAISALREPORT)
    },
    SET_APPRAISALREPORT_REPORTDATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_REPORTDATE, data)
    },
    SET_APPRAISALREPORT_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_DATE_CREATED, data)
    },
    SET_APPRAISALREPORT_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_DATE_MODIFIED, data)
    },

    SET_APPRAISALREPORT_FILE_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_FILE_ID, data)
    },
    SET_APPRAISALREPORT_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_ID, data)
    },
    SET_APPRAISALREPORT_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_NUMBER, data)
    },
    SET_APPRAISALREPORT_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_PARENT_PATH, data)
    },
    SET_APPRAISALREPORT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_PATH, data)
    },
    SET_APPRAISALREPORT_SEND_TO_BDE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SEND_TO_BDE, data)
    },
    SET_APPRAISALREPORT_TITLE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_TITLE, data)
    },
    SET_APPRAISALREPORT_VERSION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_VERSION, data)
    },
    UPDATE_APPRAISALREPORT: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            // console.log('UPDATE_APPRAISALREPORT data:')
            // console.log(data)
            api.update({object: data.object, path: data.path + data.key, save_timestamp: true})
                .then((res) => {

                    const date_modified = res.date_modified
                    commit(SET_APPRAISALREPORT_DATE_MODIFIED, res.date_modified)
                    commit(SET_APPRAISALREPORT_DIRTYNESS, false)

                    let parent_object = {}

                    parent_object = {
                        description: data.object.description,
                        id: data.object.id,
                        date_modified: res.date_modified,
                        number: data.object.number,
                        version: data.object.version,
                        send_to_bde: data.object.send_to_bde
                    }
                    api.update({object: parent_object, path: data.parent_path + data.key, save_timestamp: false})
                        .then((res) => {

                            // update file date_modified
                            api.set_value({
                                value: date_modified,
                                path: 'appraisalfiles' + '/' + data.object.file_id + '/' + 'date_modified',
                                save_timestamp: false
                            })
                                .then(res => resolve({key: res.key}))

                        })
                })

        })
    },
    SET_APPRAISALREPORT_REALESTATE_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.value,
                path: data.path,
                save_timestamp: false
            })
                .then(() => {
                    resolve()

                })

        })
    },
    UPDATE_APPRAISALREPORT_REALESTATE_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.appraisal_id,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisal_id',
                save_timestamp: false
            })
            api.set_value({
                value: data.appraisaldate,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'appraisaldate',
                save_timestamp: false
            })
            api.set_value({
                value: data.appraisal_id,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'id',
                save_timestamp: false
            })
                .then(() => {
                    resolve()

                })

        })
    },
    SET_APPRAISALREPORT_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_DESCRIPTION, data)
    },
    SET_APPRAISALREPORT_PETITIONER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_PETITIONER, data)
    },
    SET_APPRAISALREPORT_PETITIONER_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_PETITIONER_TYPE, data)
    },
    SET_APPRAISALREPORT_ENTITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_ENTITY, data)
    },
    SET_APPRAISALREPORT_SUPERVISOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SUPERVISOR, data)
    },
    SET_APPRAISALREPORT_APPRAISER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_APPRAISER, data)
    },
    SET_APPRAISALREPORT_COVER_PHOTO_URL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_COVER_PHOTO_URL, data)
    },
    SET_APPRAISALREPORT_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_STATUS, data)
    },
    SET_APPRAISALREPORT_FULL_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_FULL_NUMBER, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_NAME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_SV_NAME, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_BASE64: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_SV_BASE64, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_DATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_SV_DATE, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_UID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_SV_UID, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_NAME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_AP_NAME, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_BASE64: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_AP_BASE64, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_DATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_AP_DATE, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL, data)
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_UID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_SIGNATURE_AP_UID, data)
    },
    SET_APPRAISALREPORT_IS_SIGNED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_IS_SIGNED, data)
    },
    SET_APPRAISALREPORT_IS_SV_SIGNED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_IS_SV_SIGNED, data)
    },
    SET_APPRAISALREPORT_IS_AP_SIGNED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALREPORT_IS_AP_SIGNED, data)
    },

}

const mutations = {

    [RESET_APPRAISALREPORT] (state) {
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.file_id = null
        state.id = null
        state.number = null
        state.full_number = null
        state.path = null
        state.parent_path = null
        state.description = null
        state.reportdate = null
        state.send_to_bde = null
        state.title = null
        state.version = null
        state.petitioner = null
        state.petitioner_type = {
            id: 1,
            'name_ca': 'Altres persones físiques o jurídiques',
            'name_en': 'Other natural or legal persons',
            'name_es': 'Otras personas físicas o jurídicas'
        }
        state.entity = null
        state.supervisor = null
        state.appraiser = null
        state.cover_photo_url = null
        state.status = {
            id: 1,
            level: 1,
            progress_coef: 0.166,
            name_ca: '1/6 - Falta la firma del Taxador',
            name_es: '1/6 - Falta la firma del Tasador',
            name_en: '1/6 - Needs to be signed by Appraiser'
        }
        state.signature_sv_name = null
        state.signature_sv_base64 = null
        state.signature_sv_date = null
        state.signature_sv_email = null
        state.signature_sv_uid = null
        state.signature_ap_name = null
        state.signature_ap_base64 = null
        state.signature_ap_date = null
        state.signature_ap_email = null
        state.signature_ap_uid = null
        state.is_signed = null
        state.is_sv_signed = null
        state.is_ap_signed = null
    },
    [SET_APPRAISALREPORT] (state, data) {
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.file_id = check_undefined(data.file_id)
        state.id = check_undefined(data.id)
        state.number = check_undefined(data.number)
        state.path = check_undefined(data.path)
        state.parent_path = check_undefined(data.parent_path)
        state.description = check_undefined(data.description)
        state.reportdate = check_undefined(data.reportdate)
        state.send_to_bde = check_undefined(data.send_to_bde)
        state.title = check_undefined(data.title)
        state.version = check_undefined(data.version)
        state.petitioner = check_undefined(data.petitioner)
        state.petitioner_type = check_undefined(data.petitioner_type)
        state.entity = check_undefined(data.entity)
        state.supervisor = check_undefined(data.supervisor)
        state.appraiser = check_undefined(data.appraiser)
        state.cover_photo_url = check_undefined(data.cover_photo_url)
        state.status = check_undefined(data.status)
        state.full_number = check_undefined(data.full_number)
        state.signature_sv_name = check_undefined(data.signature_sv_name)
        state.signature_sv_base64 = check_undefined(data.signature_sv_base64)
        state.signature_sv_date = check_undefined(data.signature_sv_date)
        state.signature_sv_email = check_undefined(data.signature_sv_email)
        state.signature_sv_uid = check_undefined(data.signature_sv_uid)
        state.signature_ap_name = check_undefined(data.signature_ap_name)
        state.signature_ap_base64 = check_undefined(data.signature_ap_base64)
        state.signature_ap_date = check_undefined(data.signature_ap_date)
        state.signature_ap_email = check_undefined(data.signature_ap_email)
        state.signature_ap_uid = check_undefined(data.signature_ap_uid)
        state.is_signed = check_undefined(data.is_signed)
        state.is_sv_signed = check_undefined(data.is_sv_signed)
        state.is_ap_signed = check_undefined(data.is_ap_signed)
    },
    [SET_APPRAISALREPORT_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_APPRAISALREPORT_FILE_ID] (state, data) {
        state.file_id = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_NUMBER] (state, data) {
        state.number = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_REPORTDATE] (state, data) {
        state.reportdate = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_TITLE] (state, data) {
        state.title = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_VERSION] (state, data) {
        state.version = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_PETITIONER] (state, data) {
        state.petitioner = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_PETITIONER_TYPE] (state, data) {
        state.petitioner_type = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_ENTITY] (state, data) {
        state.entity = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SUPERVISOR] (state, data) {
        state.supervisor = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_APPRAISER] (state, data) {
        state.appraiser = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_COVER_PHOTO_URL] (state, data) {
        state.cover_photo_url = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_STATUS] (state, data) {
        state.status = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_FULL_NUMBER] (state, data) {
        state.full_number = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_SV_NAME] (state, data) {
        state.signature_sv_name = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_SV_BASE64] (state, data) {
        state.signature_sv_base64 = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_SV_DATE] (state, data) {
        state.signature_sv_date = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL] (state, data) {
        state.signature_sv_email = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_SV_UID] (state, data) {
        state.signature_sv_uid = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_AP_NAME] (state, data) {
        state.signature_ap_name = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_AP_BASE64] (state, data) {
        state.signature_ap_base64 = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_AP_DATE] (state, data) {
        state.signature_ap_date = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL] (state, data) {
        state.signature_ap_email = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_SIGNATURE_AP_UID] (state, data) {
        state.signature_ap_uid = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_IS_SIGNED] (state, data) {
        state.is_signed = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_IS_SV_SIGNED] (state, data) {
        state.is_sv_signed = data
        state.dirty = true
    },
    [SET_APPRAISALREPORT_IS_AP_SIGNED] (state, data) {
        state.is_ap_signed = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    appraisalreport: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/appraisalreport/appraisalreport.js